import axiosInstance from "../../../helpers/api";

export const createVideoVouchers = () => {
  return axiosInstance.post("/admin/video_vouchers");
};

export const getAllVideos = (body) => {
  return axiosInstance.get("/admin/videos", { params: body });
};

export const getPaymentSubjects = (body) => {
  return axiosInstance.get("/admin/payment_subject", { params: body });
};

export const addPaymentSubject = (body) => {
  return axiosInstance.post("/admin/payment_subject", body);
};

export const editPaymentSubject = (formData) => {
  return axiosInstance.put(`/admin/payment_subject/${formData.id}`, formData.formData);
};

export const editVideos = (formData) => {
  return axiosInstance.post(`/admin/videos/${formData.id}`, formData.formData);
};

export const suspendVideos = (formData) => {
  return axiosInstance.post(
    `/admin/videos/suspend/${formData.id}`,
    formData.formData
  );
};

export const createVideo = (formData) => {
  return axiosInstance.post("/admin/videos", formData);
};

export const deleteVideo = (id) => {
  return axiosInstance.delete(`/admin/videos/${id}`);
};

export const deleteVideoFile = (id) => {
  return axiosInstance.delete(`/admin/video_files/${id}`);
};

export const addVideoFiles = (formData) => {
  return axiosInstance.post(`/admin/video_files`, formData);
};

export const fixViewsCount = () => {
  return axiosInstance.put("/admin/user_videos/fix_views");
}

export const getUserVideos = (params) => {
  return axiosInstance.get("/admin/user_videos", { params });
}

export const addView = (body) => {
  return axiosInstance.post("/admin/user_videos/add_view", body);
}

export const getVideoVdoChapters = (id) => {
  return axiosInstance.get(`/admin/videos/vdo_chapters/${id}`);
}

export const updateVideoVdoChapters = (id, body) => {
  return axiosInstance.put(`/admin/videos/vdo_chapters/${id}`, body);
}

export const addVideoQuestion = (body) => {
  return axiosInstance.post("/admin/videos/add_question", body);
}
